import { css, cx } from '@emotion/css'
import { NavLink } from 'react-router-dom'
import { Home, Compass, User } from 'lucide-react'
import { theme } from '../styles/theme.js'

const styles = {
  nav: css({
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '64px',
    backgroundColor: theme.colors.surface,
    borderTop: `1px solid ${theme.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    zIndex: 100,
    paddingBottom: 'env(safe-area-inset-bottom, 0px)',
    '@media (min-width: 768px)': {
      display: 'none',
    },
  }),
  link: css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '2px',
    color: theme.colors.textMuted,
    fontSize: theme.typography.fontSize.sm,
    fontWeight: 500,
    minWidth: '64px',
    minHeight: '48px',
    padding: theme.spacing.xs,
    borderRadius: theme.radii.sm,
    transition: 'color 0.15s ease',
    '&.active': {
      color: theme.colors.primary,
    },
  }),
  icon: css({
    width: '22px',
    height: '22px',
  }),
  label: css({
    fontSize: '10px',
    letterSpacing: '0.5px',
    textTransform: 'uppercase',
  }),
}

const navItems = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/explore', label: 'Explore', icon: Compass },
  { to: '/profile', label: 'Profile', icon: User },
]

const BottomNav = () => {
  return (
    <nav className={styles.nav}>
      {navItems.map((item) => {
        const Icon = item.icon
        return (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cx(styles.link, isActive && 'active')
            }
            end={item.to === '/'}
          >
            <Icon className={styles.icon} />
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        )
      })}
    </nav>
  )
}

export { BottomNav }
